"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC6551RegistryAbi = exports.ERC1155CreatorAbi = exports.ERC1155Abi = exports.ERC721CreatorAbi = exports.ERC721Abi = exports.BackpackRegistryAbi = exports.BackpackAbi = void 0;
const tslib_1 = require("tslib");
const Backpack_json_1 = tslib_1.__importDefault(require("./Backpack.json"));
exports.BackpackAbi = Backpack_json_1.default;
const BackpackRegistry_json_1 = tslib_1.__importDefault(require("./BackpackRegistry.json"));
exports.BackpackRegistryAbi = BackpackRegistry_json_1.default;
const ERC721Contract_json_1 = tslib_1.__importDefault(require("./ERC721Contract.json"));
exports.ERC721Abi = ERC721Contract_json_1.default;
const ERC721Creator_json_1 = tslib_1.__importDefault(require("./ERC721Creator.json"));
exports.ERC721CreatorAbi = ERC721Creator_json_1.default;
const ERC1155Contract_json_1 = tslib_1.__importDefault(require("./ERC1155Contract.json"));
exports.ERC1155Abi = ERC1155Contract_json_1.default;
const ERC1155Creator_json_1 = tslib_1.__importDefault(require("./ERC1155Creator.json"));
exports.ERC1155CreatorAbi = ERC1155Creator_json_1.default;
const ERC6551Registry_json_1 = tslib_1.__importDefault(require("./ERC6551Registry.json"));
exports.ERC6551RegistryAbi = ERC6551Registry_json_1.default;
//# sourceMappingURL=index.js.map